<div class="add-to-group">
  <coa-add-to-group-header></coa-add-to-group-header>

  <coa-add-to-group-body
    (showCreateGroup)="showCreateGroup.emit()"
    [clientId]="clientId"
    [selections]="selections">
  </coa-add-to-group-body>
</div>
